import * as Styles from './BarChartAvatar.styles';

export type BarChartAvatarProps = {
  backgroundColorFirst: string;
  backgroundColorSecond: string;
  firstBarWidth: number;
  secondBarWidth: number;
  label: string;
  firstBarValue: number;
  secondBarValue: number;
  firstName: string;
  lastName: string;
};

const BarChartAvatar = function ({
  label,
  firstBarWidth,
  secondBarWidth,
  backgroundColorFirst,
  backgroundColorSecond,
  firstBarValue,
  secondBarValue,
  firstName,
  lastName,
}: BarChartAvatarProps): JSX.Element {
  return (
    <Styles.Container>
      <Styles.Row>
        <div className="flex align-center">
          <Styles.CustomUserInitials firstName={firstName} lastName={lastName} />
          <Styles.Label>{label}</Styles.Label>
        </div>
        <Styles.Lines>
          <Styles.ThinBar width={firstBarWidth} background={backgroundColorFirst}>
            <Styles.Value>{firstBarValue}</Styles.Value>
          </Styles.ThinBar>
          <Styles.ThinBar width={secondBarWidth} background={backgroundColorSecond}>
            <Styles.Value>{secondBarValue}</Styles.Value>
          </Styles.ThinBar>
        </Styles.Lines>
      </Styles.Row>
    </Styles.Container>
  );
};

export default BarChartAvatar;
